import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const EnvironmentIndicatorContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
`

interface EnvironmentPillProps {
  environment: string
}

export const EnvironmentPill = styled.div<EnvironmentPillProps>`
  padding: ${Spacing.S4} ${Spacing.S12};
  border-bottom-right-radius: ${BorderRadius.R8};
  border-bottom-left-radius: ${BorderRadius.R8};
  background-color: ${({ environment }) => (environment === 'staging' ? Color.Yellow200 : Color.Grey100)};
`
